import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const auth = useState('auth', () => ({
    isAuthenticated: false,
    user: null,
    csrf: null,
    carts: {},
    social: false,
    currentCountry: 'MY'
  }))


  nuxtApp.hooks.hook('app:created', () => {
    const initialAuth = nuxtApp.ssrContext?.event.context.auth
    if (initialAuth) {
      const csrfs = { csrf: nuxtApp.ssrContext?.event.context.csrf, csrf_server: nuxtApp.ssrContext?.event.context.csrf_server };
      auth.value = { ...initialAuth, ...csrfs }
    }
  })

  return {
    provide: {
      auth
    }
  }
})